const WrapperStyles = (theme) => ({
    root: {
        padding: theme.spacing.unit,
    },
});

export default WrapperStyles;
